module.exports = __webpack_public_path__ + "static/6776ca39.link2.png";